"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const AriFormUtils = __importStar(require("../../utils/utils"));
const Component_1 = __importDefault(require("../_classes/component/Component"));
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
class HTMLComponent extends Component_1.default {
    static schema(...extend) {
        return Component_1.default.schema({
            label: 'HTML',
            type: 'htmlelement',
            tag: 'div',
            attrs: [],
            content: '',
            input: false,
            persistent: false
        }, ...extend);
    }
    static get builderInfo() {
        return {
            title: 'HTML Element',
            group: 'layout',
            icon: 'code',
            weight: 0,
            documentation: '/userguide/form-building/layout-components#html-element',
            showPreview: false,
            schema: HTMLComponent.schema()
        };
    }
    static savedValueTypes() {
        return [];
    }
    get defaultSchema() {
        return HTMLComponent.schema();
    }
    get content() {
        if (this.builderMode) {
            return this.component.content;
        }
        // i18n returns error exactly with word 'select', spaces will be trimmed
        if (this.component.content.replace(/(<(\/?[^>]+)>)/g, '').trim() === 'select') {
            return ` ${this.component.content} `;
        }
        const submission = lodash_1.default.get(this.root, 'submission', {});
        const content = this.component.content ? this.interpolate(this.sanitize(this.component.content, this.shouldSanitizeValue), {
            metadata: submission.metadata || {},
            submission: submission,
            data: this.rootValue,
            row: this.data,
            // hungnq - add form to content for support render value in form
            form: this.root
            // end hungnq
        }) : '';
        return content;
    }
    get singleTags() {
        return ['br', 'img', 'hr'];
    }
    checkRefreshOn(changed) {
        super.checkRefreshOn(changed);
        let visible;
        if (this.hasCondition()) {
            this._conditionallyHidden = this.checkConditionallyHidden();
            visible = !this.conditionallyHidden;
        }
        else {
            visible = !this.component.hidden;
        }
        const shouldSetContent = !this.builderMode
            && this.component.refreshOnChange
            && this.element
            && !lodash_1.default.isUndefined(changed)
            && ((lodash_1.default.isBoolean(changed) && changed) || !lodash_1.default.isEmpty(changed))
            && visible;
        if (shouldSetContent) {
            this.setContent(this.element, this.renderContent());
        }
    }
    //Simple setValue
    setValue(value) {
        if (value) {
            //this.component.input = true; //force allow set value
            super.setValue(value);
            this.setContent(this.renderContent());
            this.redraw();
        }
    }
    //end simple
    // hungnq 
    formatContetn(value) {
        if (this.component.numberFormat) {
            return AriFormUtils.numberWithCommas(value, this.component.decimal);
        }
        else if (this.component.datetimeFormat) {
            return (0, moment_1.default)(value).format(this.component.datetimeFormatTemplate || 'dd/MM/yyyy HH:mm');
        }
        else {
            return value;
        }
    }
    // end hungnq 
    //Fiona
    renderContent() {
        var _a;
        const submission = lodash_1.default.get(this.root, 'submission', {});
        const tag = !!this.component.htmlTag && this.component.htmlTag !== 'custom' ? this.component.htmlTag : this.component.tag;
        const selectClass = ((_a = this.component.elementType) === null || _a === void 0 ? void 0 : _a.length) > 0 ? this.component.elementType.join(' ') : '';
        const className = `${this.component.className ? this.component.className : ''} ${selectClass}`;
        const content = this.formatContetn(this.getValue() || this.content);
        return this.renderTemplate('html', {
            component: this.component,
            tag: tag,
            attrs: (this.component.attrs || []).map((attr) => {
                return {
                    attr: attr.attr,
                    value: this.interpolate(attr.value, {
                        metadata: submission.metadata || {},
                        submission: submission,
                        data: this.rootValue,
                        row: this.data
                    })
                };
            }),
            className: className,
            content: content,
            singleTags: this.singleTags,
        });
    }
    //end
    render() {
        return super.render(this.renderContent());
    }
    get dataReady() {
        var _a;
        return ((_a = this.root) === null || _a === void 0 ? void 0 : _a.submissionReady) || Promise.resolve();
    }
    attach(element) {
        this.loadRefs(element, { html: 'single' });
        this.dataReady.then(() => {
            if (this.refs.html) {
                this.setContent(this.refs.html, this.content);
            }
        });
        return super.attach(element);
    }
}
exports.default = HTMLComponent;
